import React from 'react';
import SpinnerSolid from '@/Components/UI/Spinner/SpinnerSolid';

const LoadingOverlay = () => {
  return (
    <div className='loader-container'>
      <SpinnerSolid size='large' color='midnight' />
    </div>
  );
};

export default LoadingOverlay;
